<template>
  <div @click="$emit('click')" style="cursor: pointer; display: flex; align-items: center;">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M9 18L15 12L9 6" :stroke="iconColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </div>
</template>

<script>
export default {
  name: "RightArrowIcon",
  props: {
    color: {
      type: String,
      default: "#323232"
    }
  },
  computed: {
    iconColor() {
      return this.color;
    }
  }
};
</script>
